import { streamAgentMessage } from "./agentStreamService";
import {
  createAgentRunnerSession,
  pingAgentRunnerSession,
} from "./agentRunnerClient";
import type { AgentSseHandlers } from "../../utils/parseAgentSseStream";
import type { AgentChatResponse } from "../../types/agentChat";
import { agentApiBase } from "../../utils/agentApiBase";

const AGENT_ID = "product-manager";

export type ProductManagerChatResponse = AgentChatResponse;

export async function createProductManagerSession(): Promise<ProductManagerChatResponse> {
  const sessionId = await createAgentRunnerSession(AGENT_ID);
  return { session_id: sessionId, response: "" };
}

export async function pingProductManagerSession(
  sessionId: string,
): Promise<boolean> {
  return pingAgentRunnerSession(AGENT_ID, sessionId);
}

export async function streamProductManagerMessage(
  sessionId: string,
  message: string,
  handlers: AgentSseHandlers = {},
): Promise<ProductManagerChatResponse> {
  const base = await agentApiBase(AGENT_ID);
  return streamAgentMessage(
    base,
    sessionId,
    message,
    handlers,
    "Product manager agent error",
  );
}
